import React, { useState, useEffect } from "react";
import "./login.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { database, realtimeDatabase } from "../../database/firebase";
import { getDatabase, ref, get, set } from "firebase/database";
import axios from "axios";
import Swal from 'sweetalert2';

function Login({ updateHeader }) {
  const location = useLocation();
  // Use URLSearchParams to access the query parameters
  const queryParams = new URLSearchParams(location.search);
  const getOtp = queryParams.get('otp');
  const role = queryParams.get('role');
  const [otp, setOtp] = useState(getOtp);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // To control login state
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, setRiddlerusLogo] = useState("/img/logo.png");
  const navigate = useNavigate();
  const [isLogoSet, SetIsLogoSet] = useState(false);

  const handleSuccess = (msg) => {
    Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };

  const handleError = (msg) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  function generateRandomUser() {
    const randomString = 'demo' + Math.floor(Math.random() * 10000);
    return {
      data: {
        data: {
          // id: Math.floor(Math.random() * 100000),
          // email: `${randomString}@gmail.com`,
          // userId: randomString,
          // gameId: randomString,
          // firstName: randomString,
          // lastName: randomString,
          // employeeId: `EM${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
          // sessionId: "demobypass",
          // organizationId: "demobypass"
          id: Math.floor(Math.random() * 100000),
          email: `demo8398demo@gmail.com`,
          userId: "demo83988398",
          gameId: "DA073651E9EFE6FC3E6AB16",
          firstName: "demo",
          lastName: "demo8398",
          employeeId: `EM${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
          sessionId: "demobypass",
          organizationId: "demobypass"
        }
      }
    };
  }
  const handleLogin = () => {
    if (queryParams.get('save')) {
      console.log("ignoring latest update...");
    } else {

      if (queryParams.get('demo') === 'true') {
        // const userId=;
        // const email=;
        // const firstName=;
        const response = generateRandomUser();

        loginCheck(response, "demo");
      } else {

        let apiUrl;
        const requestData = { otp: otp };
        let source = null;

        if (role === 'GUEST_USER') {
          apiUrl = process.env.REACT_APP_FIREBASE_GUEST_USER_API;
          requestData.role = 'GUEST_USER';
          source = 'GUEST_USER'
        } else {
          apiUrl = process.env.REACT_APP_FIREBASE_LOGIN_API;
          source = 'ORG_USER'
        }


        // const headers = {
        //   'client-secret': process.env.REACT_APP_FIREBASE_CLIENT_SECRET,
        //   'Content-Type': 'application/json'
        // };

        // const method = "POST";
        // if (["POST", "PUT"].includes(method)) {
        //   headers["Idempotency-Key"] = uuidv4();
       
        // }
    
      const headers = {
        'client-secret': process.env.REACT_APP_FIREBASE_CLIENT_SECRET,
        'Content-Type': 'application/json',
        'Idempotency-Key': uuidv4(),
      };
    
        console.log(apiUrl);
        axios.post(apiUrl, requestData, { headers })
          .then(response => {
            console.log("API TRIGGER", response);
            if (response.data.message === 'LOGIN SUCCESS') {
              // Prepare headers for organization API with user token
              // const orgHeaders = {
              //   'Content-Type': 'application/json'
              // };

               axios.get(
                process.env.REACT_APP_ORG_API + "/" + response.data.data.organizationId,
                { headers } // Ensure headers are included properly
              )
                .then(responseOrg => {
                  if (responseOrg.data.message === 'ORGANIZATIONS_FETCHED_SUCCESSFULLY') {
                    let companyLogo = "";
                    console.log("companyLogo", companyLogo);
                    if (responseOrg.data?.organization.companyLogo == "" || responseOrg.data?.organization.companyLogo == null || responseOrg.data?.organization.companyLogo == undefined) {
                      companyLogo = process.env.REACT_APP_EM_LOGO;
                    } else {
                      companyLogo = process.env.REACT_APP_S3BUCKET_URL + '/' + responseOrg.data.organization.companyLogo;
                    }

                    updateHeader({
                      imageUrl: companyLogo,
                      backButtonRedirect: process.env.REACT_APP_BASE_URL + "/game-detail/" + response.data.data.gameId,
                    });
                  }
                  console.log("responseOrg", responseOrg);
                })
                .catch(error => {
                  console.error("Error fetching organization:", error);
                });
              console.log(response);
              loginCheck(response, source);
            } else {
              handleError('Login failed! Please try again.');
            }

          })
          .catch(error => {
            console.error('Login Failed:', error.response?.data?.err?.message || 'An error occurred');
            handleError('Login failed! Please try again.');

          });
      }
    }
  };

  function loginCheck(response, source) {

    console.log(response);

    const userId = role === 'GUEST_USER'
      ? response.data.data.id
      : response.data.data.userId;

    let name = `${response.data.data.firstName} ${response.data.data.lastName}`;
    let email;

    if (role === 'GUEST_USER' && (response.data.data.firstName === "" || response.data.data.firstName === null)) {
      //alert(response.data.data.employeeId);
      if (response.data.data.email) {
        // Extract the part before '@' in the email (email has priority)
        name = response.data.data.email.split('@')[0];
        email = response.data.data.email;

      } else if (response.data.data.employeeId) {
        // Use employeeId as name if email is not present (although email will be present as per your note)
        name = response.data.data.employeeId;
        email = response.data.data.employeeId;
        //alert(name);
      } else {
        name = 'Guest'; // Fallback name if both email and employeeId are unavailable
      }
    } else if (role === 'GUEST_USER' && response.data.data.firstName != "") {

      if (response.data.data.email) {
        // Extract the part before '@' in the email (email has priority)
        name = response.data.data.firstName;
        email = response.data.data.email;

      } else if (response.data.data.employeeId) {
        // Use employeeId as name if email is not present (although email will be present as per your note)
        name = response.data.data.firstName;
        email = response.data.data.employeeId;
      } else {
        name = response.data.data.firstName; // Fallback name if both email and employeeId are unavailable
      }
    } else {
      email = response.data.data.email;
    }

    const userData = {
      userId: userId,
      sessionId: response.data.data.sessionId,
      organizationId: response.data.data.organizationId,
      name: name,
      email: email,
      expiry: new Date().getTime() + 24 * 60 * 60 * 1000,
      source: source,
      live: true,
      gameId: response.data.data.gameId,
      status: "online",
      ...(response.data.data.token && { token: response.data.data.token }),
    };
    console.log("userData", userData);

    sessionStorage.setItem('userData', JSON.stringify(userData));

    // Reference to the user's document inside the session's users collection
    const userDocRef = ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`);

    // Check if the user already exists
    get(userDocRef)
      .then((userSnapshot) => {
        if (userSnapshot.exists()) {
       
          console.log("Current user already exists!");

          // Merge fresh login data (incl. source/role) over Firebase record so guest vs org routing stays correct
          const existingUserData = userSnapshot.val();
          sessionStorage.setItem("userData", JSON.stringify({ ...existingUserData, ...userData }));

          if (queryParams.get('admin')) {
            window.location.href = process.env.REACT_APP_ADMIN_REDIRECT + '?sessionId=' + response.data.data.sessionId + "&userId=" + userData.userId + "&organizationId=" + response.data.data.organizationId + "&gameId=" + response.data.data.gameId;
            return; // Early return to avoid fetching theme data
          }

          getallthemedata(response, userData.userId);

        } else {
          // If the user doesn't exist, add a new document
          set(userDocRef, {
            userId: userData.userId,
            organizationId: userData.organizationId,
            sessionId: userData.sessionId,
            name: userData.name,
            email: userData.email,
            timestamp: Date.now(),
            source: source,
            live: true,
            gameId: userData.gameId,
            status: "online"
          })
            .then(async () => {
              console.log("User document created successfully");
              //setIsLoggedIn(true); // Set login state for new users

              try {
                const addUserRes = await fetch(
                  `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}events-game.php?events=adduserdata`,
                  {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                      userId: userData.userId,
                      organizationId: userData.organizationId,
                      sessionId: userData.sessionId,
                      name: userData.name,
                      email: userData.email,
                      timestamp: Date.now(),
                    })
                  }
                );
                const responseData = await addUserRes.json().catch(() => ({}));
                console.log('API Response:userdata add ', responseData);

                if (addUserRes.ok && responseData) {
                  console.log("succesfull");
                } else if (!addUserRes.ok) {
                  throw new Error(responseData?.message || 'Failed to add user data');
                }
              } catch (error) {
                console.error('Error adding user data:', error);
                Swal.fire('Error', 'Failed to add user data', 'error');
              }

              if (queryParams.get('admin')) {
                window.location.href = `${process.env.REACT_APP_ADMIN_REDIRECT}?sessionId=${userData.sessionId}&userId=${userData.userId}&organizationId=${userData.organizationId}&gameId=${userData.gameId}`;
                return; // Early return to avoid fetching theme data
              }

              // Fetch theme data for new users
              getallthemedata(response, userData.userId);
            })
            .catch((error) => {
              console.error("Error creating user document:", error);
              handleError("There was an error creating your user document. Please try again.");
            });
        }
      })
      .catch((error) => {
        handleError("Login failed! Please try again.");
        console.error("Error processing user data:", error);
      });

  }
  function getallthemedata(response, userId) {
   
    console.log(process.env.REACT_APP_FETCH_THEMEDATA + '?sessionId=' + response.data.data.sessionId + "&userId=" + userId + "&organizationId=" + response.data.data.organizationId);
    fetch(process.env.REACT_APP_FETCH_THEMEDATA + '?sessionId=' + response.data.data.sessionId + "&userId=" + userId + "&organizationId=" + response.data.data.organizationId) // Replace with your API URL
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        setIsLoggedIn(true);
        setThemeData(json);
         console.log("fetchthemedata", JSON.stringify(json));
        sessionStorage.setItem('themeData', JSON.stringify(json));
        json.form_default.timer = Number(json.timer || 0);       // copy json.timer into form_default
        json.form_default.statictimer = Number(json.timer || 0);
        CheckThemeSet(response.data.data.sessionId, json.form_default, json.themeName);
        console.log(json);
      })
      .catch((err) => {
        console.log(err.message); // Handle error
      });
  }
  async function CheckThemeSet(sessionId, themedataarray, themeName) {
    console.log("themedataarray", themedataarray);

    if (!themedataarray || themedataarray.length === 0) {
      console.error("themedataarray data is empty or undefined. Cannot proceed.");
      return;
    }

    const gameRef = ref(realtimeDatabase, `sessions/${sessionId}/themes/${themeName}`);

    try {
      // Get the document snapshot
      const docSnapshot = await get(gameRef);

      if (docSnapshot.exists()) {
        const gameData = docSnapshot.val();
        console.log("Game Data:", gameData);
        setIsLoggedIn(true);
        console.log("isLoggedIn", isLoggedIn);
      } else {
        console.warn("Game session document does not exist. Creating new session...");

        // Create the document with default values if it doesn't exist
        await set(gameRef, {
          ...themedataarray,
          sessionId
        });
        setIsLoggedIn(true);
        console.log("New game session document created.");


      }
    } catch (error) {
      console.error("Error checking or creating game session document:", error);
    }

  }


  useEffect(() => {
    // First-time login
    const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    if (storedUserData) {
      sessionStorage.removeItem('userData');
    }
    handleLogin();
  }, []); // Runs once on component mount

  useEffect(() => {
    if (themeData) {
      const body = document.body;

      const backgroundImage = window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
      if (body.classList.contains('common-bg')) {
        body.style.backgroundImage = `url(${backgroundImage})`;
      }
      setRiddlerusLogo(themeData.logo);
      SetIsLogoSet(true);
    }
  }, [themeData]);

  return (
    <>
      {
        <div className="login-main-container" style={{ textAlign: "center" }}>
          <img src={riddlerusLogo} className="login-logo" alt="Riddlerus Logo" />
          {isLoggedIn ? (
            <div style={{ textAlign: "center" }}>
              <Link to="/intro">
                <img src="/img/next-button.png" className="begin-play-img" alt="Begin Play" />
              </Link>
            </div>
          ) : (
            <></>
          )}
        </div>
      }

    </>
  );
}

export default Login;
